import { HttpStatusCode } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/api';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Fornecedor } from 'src/app/admihair/api/dto/fornecedor';
import { Municipio } from 'src/app/admihair/api/dto/municipio';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { Uf } from 'src/app/admihair/api/dto/uf';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { FornecedorService } from 'src/app/admihair/service/fornecedor.service';
import { MunicipioService } from 'src/app/admihair/service/municipio.service';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { UfService } from 'src/app/admihair/service/uf.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-fornecedor-inserir',
  templateUrl: './fornecedor-inserir.component.html',
  styleUrls: ['./fornecedor-inserir.component.scss']
})
export class FornecedorInserirComponent implements OnInit {

  permissaoInserir: boolean = false;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  progressoRequisicao: boolean = false;
 
  fornecedor: Fornecedor = {};
  empresaSelecionada?: Empresa;
  planoContaEmpresa?: PlanoContaEmpresa;
  planoCadastrado?: boolean;

  listaUfs: Uf[] = [];
  ufSelecionado?: Uf;
  isUfSelecionada: boolean = false;
  listaMunicipios: Municipio[] = [];
  municipioSelecionado?: Municipio;
  enderecoRequerido: boolean = false;
  @ViewChild('f') form?: NgForm;
 

  constructor(private fornecedorService: FornecedorService,
    private planoContaEmpresaService: PlanoContaEmpresaService,
    private utilStorageService: UtilStorageService,
    private erroService: ErroService,
    private municipioService: MunicipioService,
    private ufService: UfService,) { }


  ngOnInit(): void {
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_FORNECEDOR');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    if (this.permissaoInserir) {
      this.listarUfs();
      this.buscarPlanoConta();
    }
  }

  salvarFornecedor(){
    this.progressoRequisicao = true;
    this.fornecedor.empresaId = this.empresaSelecionada?.id;
    if(this.fornecedor.cnpj === undefined || this.fornecedor.cnpj === null){
      this.fornecedor.cnpj = '';
    }
    if(this.planoCadastrado){
      this.fornecedor.planoContaEmpresa = this.planoContaEmpresa;
    } else {
      console.log('cadastrar plano');
    }
    if(this.ufSelecionado && this.municipioSelecionado){
      this.fornecedor.uf = this.ufSelecionado?.siglaUf;
      this.fornecedor.cidade = this.municipioSelecionado?.descricao;
    } else {
      this.fornecedor.uf = this.empresaSelecionada?.uf;
      this.fornecedor.cidade = this.empresaSelecionada?.cidade;
    }
    
    this.fornecedorService.salvar(this.fornecedor).subscribe({
      next: (data: Fornecedor) => {
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.limparFormulario();
        this.rolarTela();
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.rolarTela();
      } 
    }); 
  }

  /*
  salvarPlanoConta(){
    this.planoContaEmpresa.empresa = this.empresaSelecionada;
    this.planoContaEmpresa.configuravel = 'F';
    this.planoContaEmpresa.planoContaGrupo = {id: 13};
    this.planoContaEmpresa.configuracao = {id: 0};
    console.log(this.planoContaEmpresa);
    
    this.planoContaEmpresaService.salvar(this.planoContaEmpresa).subscribe({
      next: (data: PlanoContaEmpresa) => {
        console.log('plano salvo:', data);
        this.salvarFornecedor(data)
      },
      error: (err: any) => {
        console.log('erro ao salvar plano;', err);
      }
    })
  }*/

  buscarPlanoConta(){
    const codigo = 22;
      this.planoContaEmpresaService.buscarPorEmpresaECodigo(this.empresaSelecionada?.id, codigo)
      .subscribe({
        next: (data: PlanoContaEmpresa) => {
          this.planoContaEmpresa = data;
          this.planoCadastrado = true;
        },
        error: (err: any) => {
          if(err.status === HttpStatusCode.NotFound){
            this.planoCadastrado = false;
          }
          console.log('erro ao consultar planos', err);
        }
      })
    }
  

  listarUfs() {
    this.ufService.listarUf().subscribe({
      next: (data: Uf[]) => {
        this.listaUfs = data;
      },
      error: (err: any) => {
        console.log('erro ao consultar uf', err);

      }
    }
    )

  }

  listarMunicipios(){
    if(this.ufSelecionado){
      this.enderecoRequerido = true;
      this.isUfSelecionada = true;
      this.municipioService.listarMuniciosPorUf(this.ufSelecionado.codigoUf).subscribe({
        next: (data: Municipio[]) => {
          this.listaMunicipios = data;
        },
        error: (err: any) => {
          console.log('erro ao consultar municipio', err);
        }
      }
      )
    }
  }

  selecionaCidade(){
    if(this.municipioSelecionado){
      this.enderecoRequerido = false;
    }
  }

  verificarPermissao(nome: string): boolean{
    return AuthUtil.verificarPermissao(nome);
  }

  ocultarMensagem(){
    if(this.messagemVisivel){
      this.messagemVisivel = false;
    }
  }
  limparFormulario(){
    this.form?.reset();
    this.isUfSelecionada = false;
  }
  
  ocultarMsg(){
    this.messagemVisivel = false;
  }
  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
  

}
